import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { utilButton } from "../../../utils/utilButton";
import { IdButtonType } from "./IdButtonType";
export var BaseButton = function (_a) {
    var name = _a.name, children = _a.children, onClick = _a.onClick, className = _a.className, disabled = _a.disabled, _b = _a.styleId, styleId = _b === void 0 ? IdButtonType.ButtonSquareLarge : _b, soundId = _a.soundId;
    var buttonName = disabled ? IdStyles.ButtonDisabled : name;
    var buttonClass = className ? className : "";
    return (React.createElement("div", { className: "base-button " + buttonName + " " + styleId + " " + buttonClass, onClick: disabled ? undefined : function () { return utilButton.onClickWithSound(onClick, soundId); }, "aria-disabled": disabled }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/base-button/BaseButton.tsx
// module id = 48
// module chunks = 3